<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const ready = ref(false);
const bitrixBtn = ref(null);
let timer = null;

const setReady = () => {
  if (!ready.value) {
    ready.value = true;
    document.body.classList.add('hide-b24-btn');
    if (timer) clearInterval(timer);
    timer = null;
  }
};

const checkReady = () => {
  const apiReady = (window.B24ChatWidget && typeof window.B24ChatWidget.open === 'function') ||
    (window.B24LiveChat && typeof window.B24LiveChat.open === 'function');
  if (apiReady) return setReady();

  const btn = document.querySelector('.b24-widget-button-open, .b24-widget-button, .b24-widget-button-pulse');
  if (btn) {
    bitrixBtn.value = btn;
    return setReady();
  }
};

onMounted(() => {
  checkReady();
  if (!ready.value) {
    timer = setInterval(checkReady, 500);
  }
});

onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
  document.body.classList.remove('hide-b24-btn');
});

const openSupport = () => {
  if (window.B24ChatWidget && typeof window.B24ChatWidget.open === 'function') {
    window.B24ChatWidget.open();
    return;
  }
  if (window.B24LiveChat && typeof window.B24LiveChat.open === 'function') {
    window.B24LiveChat.open();
    return;
  }
  if (bitrixBtn.value) {
    bitrixBtn.value.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    return;
  }
  console.warn('Bitrix24 widget is not loaded yet or API not found.');
};
</script>

<template>
  <button v-if="ready" class="support-btn" type="button" @click="openSupport" aria-label="Техподдержка" title="Техподдержка">
    <span class="waves"></span>
    <span class="waves waves-2"></span>
    <i class="bi bi-chat-dots-fill"></i>
  </button>

</template>

<style scoped>
.support-btn {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 10001;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #ff7a00, #ff9800);
  box-shadow: 0 10px 24px rgba(255, 122, 0, 0.35), 0 2px 8px rgba(0, 0, 0, 0.08);
}

.support-btn .bi {
  font-size: 22px;
}

.support-btn .waves {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(255, 152, 0, 0.28);
  animation: pulse 2.2s ease-out infinite;
}

.support-btn .waves-2 {
  animation-delay: 1.1s;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  70% {
    transform: scale(1.9);
    opacity: 0;
  }
  100% {
    transform: scale(2.1);
    opacity: 0;
  }
}

.support-btn:active {
  transform: translateY(1px);
}
</style>
